import { render, staticRenderFns } from "./ScriveSignerRoleManagement.vue?vue&type=template&id=b52a0cf6&"
import script from "./ScriveSignerRoleManagement.vue?vue&type=script&lang=ts&"
export * from "./ScriveSignerRoleManagement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports